export const ymap = (data) => {
    try {
        let myMap;

        let activeFilter = null;
        let showMyPlace  = false;
        let clusterer;
        let placemarkArray = [];


        const getPointOptions2 = function () {
            const iconImageSize = sizeMark; // Размер изображения
            return {
                iconLayout: "default#image",
                iconImageHref: "/img/svg/marker-inflave-black.svg",
                iconImageSize: iconImageSize,
                iconOffset: [-12, 19], // Центрирование по размеру изображения
                balloonOffset: [-118.3, -4],
                hideIconOnBalloonOpen: false, // Оставляем иконку при открытии балуна
            };
        };


        document.querySelector('.js-geo-shops').addEventListener('click', function() {
            var location = ymaps.geolocation;


            // Получение местоположения и автоматическое отображение его на карте.
            location.get({
                mapStateAutoApply: true
            })
            .then(
            function(result) {
             
                console.log(result,"result");
                // Получение местоположения пользователя.
                var userAddress = result.geoObjects.get(0).properties.get('text');
                var userCoodinates = result.geoObjects.get(0).geometry.getCoordinates();
                console.log(userAddress,"userAddress");
                console.log(userCoodinates,"userCoodinates");
                // Пропишем полученный адрес в балуне.
            //     result.geoObjects.get(0).properties.set({
            //         balloonContentBody: 'Адрес: ' + userAddress +
            //                             '<br/>Координаты:' + userCoodinates
            // });
               // myMap.geoObjects.add(result.geoObjects); 

            if(!showMyPlace){
                var myPlacemarkNew = new ymaps.Placemark(userCoodinates, null, {
                    preset: 'islands#blackCircleDotIcon'
                });
                clusterer.add(myPlacemarkNew);
                showMyPlace = true;
            }
    

            myMap.setCenter(result.geoObjects.get(0).geometry.getCoordinates(), 16);
            myMap.setZoom(16);
              
                //myMap.setCenter(result.geoObjects.get(0).geometry.getCoordinates(), 5, {duration: 300});
           
            },
            function(err) {
                console.log('Ошибка: ' + err)
            }
            );

        });

        let net = data['networks'];
        data = data['shops'];
        
        let sizeMark = [47, 19];
        ymaps.ready(init);

      
        let loaderBlock = document.querySelector('.where__loader');


        // loader для карты
        function withLoad(load) {
            load ? console.log('start load') : console.log('finish load')
            load ? loaderBlock.classList.add('js-map-load') : loaderBlock.classList.remove('js-map-load');
        }



        function init() {

            // custom placemark
            const getPointOptions = function () {
                const iconImageSize = sizeMark; // Размер изображения
                return {
                    iconLayout: "default#image",
                    iconImageHref: "/img/svg/marker-inflave-black.svg",
                    iconImageSize: iconImageSize,
                    iconOffset: [-12, 19], // Центрирование по размеру изображения
                    balloonOffset: [-118.3, -4],
                    hideIconOnBalloonOpen: false, // Оставляем иконку при открытии балуна
                };
            };
            // Search
            // шаблон
            var searchLayout = ymaps.templateLayoutFactory.createClass(
                `
                <form name="search-form" id="search-form">
                    <input id="search-field" class="input-reset search-input" type="text" placeholder="Введите адрес"/>
                    <input type="submit" class="btn-reset search-form__btn" role="submit" id="search-btn" value="Найти"></input>
                    <button class="btn-reset search-form__btn-mobile" type="submit">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
                            <path d="M9.84799 9.43434L7.38281 6.87043C8.01687 6.11814 8.36441 5.16582 8.36394 4.18197C8.36394 1.87607 6.48787 0 4.18197 0C1.87607 0 0 1.87607 0 4.18197C0 6.48787 1.87607 8.36394 4.18197 8.36394C5.04764 8.36394 5.87257 8.10284 6.57787 7.60718L9.06178 10.1905C9.1656 10.2984 9.30524 10.3578 9.45489 10.3578C9.59653 10.3578 9.7309 10.3038 9.8329 10.2056C9.93701 10.1053 9.99707 9.9677 9.9999 9.82311C10.0027 9.67852 9.9481 9.53871 9.84799 9.43434ZM4.18197 1.09095C5.88639 1.09095 7.27299 2.47754 7.27299 4.18197C7.27299 5.88639 5.88639 7.27299 4.18197 7.27299C2.47754 7.27299 1.09095 5.88639 1.09095 4.18197C1.09095 2.47754 2.47754 1.09095 4.18197 1.09095Z" fill="black"/>
                        </svg>
                    </button>
                </form>
                `, {
                build: function () {
                    searchLayout.superclass.build.call(this);
                    this.searchCallback = ymaps.util.bind(this.searchCb, this);
                    document.getElementById('search-form').addEventListener("submit", this.searchCallback);
                    var input = document.getElementById('search-field');
                    var suggestView = new ymaps.SuggestView(input);

                },
                clear: function () {
                    var searchBtn = document.getElementById('search-btn');
                    searchBtn.removeEventListener('click', this.searchCallback);

                    searchLayout.superclass.clear.call(this);
                },
                searchCb: function (e) {
                    var map = this.getData().control.getMap();
                    e.preventDefault();

                    var ctrl = this.getData().control;
                    var searchFieldValue = document.getElementById('search-field').value;

                    ctrl.search(searchFieldValue).then(function (value) {
                       
                    });
                }
            });
            // 
            var searchControl = new ymaps.control.SearchControl({
                options: {
                    formLayout: searchLayout,
                    provider: 'yandex#search',
                    useMapBounds: true,
                    noPlacemark: true,
                    float: 'none',
                    position: {
                        top: 40,
                        left: '50%'
                    },
                    size: 'large',
                    // Замените это значение на ваш созданный шаблон
                    // layout: customSearchResultLayout,
                }
            });


            // Кнопка местоположения
            const geolocationControl = new ymaps.control.GeolocationControl({
                options: {
                    position: {
                        bottom: 35,
                        right: 35,
                    },
                    width: 30,
                    height: 30
                },
            });
            // Создание карты.
             myMap = new ymaps.Map(
                "map",
                {
                    center: [55.76, 38.64], // Устанавливаем центр карты.
                    zoom: 5, // Устанавливаем уровень масштаба карты.
                    controls: [], // Отключаем стандартные элементы управления.
                },
                {
                    interactivityModel: 'as-is',
                    suppressMapOpenBlock: true, // Отключаем блок с предложением открыть карту на весь экран.
                }
            );

            let mapPage = document.querySelector(".page__body--6051");    
            if(!mapPage){
                myMap.behaviors.disable('scrollZoom');
            }
        
       
        

            //  лже-JSON.
            // data = [  
            //     {
            //         id: "1",
            //         name: "Табачный капитан",
            //         city: "Москва",
            //         address: "ул.Адмирала Макарова,14",
            //     },
            //     {
            //         id: "2",
            //         name: "Табачный капитан",
            //         city: "Москва",
            //         address: "ул.Маршала Малиновского, д.8 пом. Y1",
            //     },
            //     {
            //         id: "3",
            //         name: "Табачный капитан",
            //         city: "Москва",
            //         address: "Славянский бульвар, д.5 корп.1",
            //     },
            //     {
            //         id: "4",
            //         name: "Табачный капитан",
            //         city: "Москва",
            //         address: "ул.Адмирала Ушакова,11",
            //     },
            //     {
            //         id: "5",
            //         name: "AlCapone",
            //         city: "Саратов",
            //         address: "ул.им.Сакко и Ванцетти, 25",
            //     },
            //     {
            //         id: "6",
            //         name: "AlCapone",
            //         city: "Саратов",
            //         address: "ул.Тархова 29а/2",
            //     },
            //     {
            //         id: "7",
            //         name: "AlCapone",
            //         city: "Саранск",
            //         address: "пр. 60 лет Октября, 2/6",
            //     },
            //     {
            //         id: "8",
            //         name: "20 Грамм",
            //         city: "Омск",
            //         address: "70 лет Октября 10",
            //     },
            //     {
            //         id: "9",
            //         name: "20 Грамм",
            //         city: "Омск",
            //         address: "2-я Рыбачья улица 20",
            //     },
            //     {
            //         id: "10",
            //         name: "Симпатия",
            //         city: "Омск",
            //         address: "Булатова 100",
            //     },
            //     {
            //         id: "11",
            //         name: "Ilfumo",
            //         city: "Омск",
            //         address: "Фрунзе 80",
            //     },
            //     {
            //         id: "12",
            //         name: "VAPESHOOOP!",
            //         city: "Омск",
            //         address: "Омская 119",
            //     },
            // ];


            
        
            function getUniqueNames(data) {
                const uniqueNames = [...new Set(data.map(item => item.name))];
                return uniqueNames;
            }

            const uniqueNames = getUniqueNames(data);

            function filterGen(names) {
                let parDiv = document.querySelector('.where__filter_list');
                names.forEach(name => {
                    let name_net = name['name'];
                    let img_net = name['image'];
                    if(!img_net) img_net = "/img/svg/filter.svg";

                    let div = document.createElement('div');
                    div.classList.add('where__filter_item');
                    div.setAttribute('data-shop-name',name_net);
                    div.innerHTML = `
                    <div class="where__filter_item-left">
                        <div class="where__filter_item-circle"></div>
                        <p class="where__filter_item-name">${name_net}</p>
                      </div>
                      <img src="${img_net}" class="where__filter_item-img" alt="">
                    `;
                    parDiv.append(div)
                })
            }

            filterGen(net);

            // Создаем объект для кластеризации.
            clusterer = new ymaps.Clusterer({
                clusterIconOffset: [-22, -19],
                clusterDisableClickZoom: false,
                clusterBalloonPanelMaxMapArea: 0,
                zoomMargin: 60,
                clusterIconLayout: ymaps.templateLayoutFactory.createClass(
                    '<div class="clusterIcon">{{ properties.geoObjects.length }}</div>'
                ),
                clusterIconShape: {
                    type: "Rectangle",
                    coordinates: [[0, 0], sizeMark],
                },
            });

            // Метки в кластеризацию
            function addPlacemarksToCluster(data, filter = null, all) {

                data.forEach(function (item) {
                    console.log(item);
                 
                    if (!filter || item.name.toLowerCase() === filter.toLowerCase()) {
                      
                                let coordinates = [item.coordinate_y,item.coordinate_x];
                                

                             

                                let placemark = new ymaps.Placemark(
                                    coordinates,
                                    {
                                        balloonContent: `
                                            <div class="balloon" data-shop="${item.id}">
                      <div class="balloon__body">
                        <p class="balloon__title">
                            ${item.name}
                        </p>
                        <p class="balloon__copy">
                            Скопировано
                        </p>
                        <p class='balloon__address'>
                            г. ${item.city}, ${item.address}
                        </p>
                      </div>
                      <div class="balloon__footer">
                        <div class="balloon__route">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
                                <path d="M13.0003 7.82701C12.9747 9.41258 12.0772 10.369 10.949 11.124C10.6413 11.3253 10.3336 11.275 10.1029 10.9981C9.84645 10.6961 9.79517 10.3438 10.0516 10.0418C10.308 9.76493 10.6157 9.53842 10.8977 9.28674C11.5131 8.70788 11.6926 7.85217 11.3336 7.12231C11.0003 6.49311 10.308 6.14076 9.59004 6.2666C9.28234 6.31694 9.05157 6.46795 8.82081 6.64412C7.66696 7.57533 6.51311 8.48137 5.38491 9.41258C3.97465 10.4948 2.38491 10.5703 1.20542 9.56358C-0.102271 8.48137 -0.384322 6.79513 0.513114 5.3354C0.769524 4.90754 1.15414 4.55519 1.5644 4.27835C1.92337 4.02667 2.30799 4.05184 2.5644 4.40419C2.82081 4.75654 2.79517 5.10889 2.48747 5.4109C2.2567 5.63741 1.94901 5.81358 1.76952 6.1156C1.33363 6.82029 1.43619 7.80184 2.05158 8.35553C2.64132 8.90922 3.51311 8.90922 4.17978 8.3807C5.38491 7.42432 6.5644 6.46795 7.76952 5.51157C8.79516 4.68103 9.94901 4.47969 11.1541 5.05855C12.3849 5.61224 12.949 6.64412 13.0003 7.82701Z" fill="#B2B2B2"/>
                                <path d="M5.46178 5.23476C5.07716 5.23476 4.89768 5.10892 4.69255 4.93275C3.87203 4.12738 3.05152 3.32201 2.23101 2.49147C1.69255 1.93778 1.82075 1.35892 2.56434 1.13241C3.76947 0.754894 4.9746 0.402545 6.20537 0.0501958C6.89768 -0.151147 7.38486 0.352209 7.20537 1.03174C6.84639 2.23979 6.46178 3.44785 6.1028 4.68107C6.00024 5.00825 5.74383 5.20959 5.46178 5.23476Z" fill="#B2B2B2"/>
                                <path d="M9.56482 12.76C9.56482 14.0184 8.51354 15.0251 7.23149 14.9999C5.97508 14.9747 4.94944 13.9429 4.97508 12.7096C5.00072 11.5016 6.02636 10.4949 7.25713 10.4949C8.53918 10.4949 9.56482 11.5268 9.56482 12.76Z" fill="#B2B2B2"/>
                            </svg>
                            <a class="balloon__route_text" target="_blank" href="https://yandex.ru/maps/?rtext=~${coordinates}">Построить маршрут</a>
                        </div>
                        <button class="btn-reset balloon__address_btn-feedback js-balloon-feedback" data-graph-path="shop-message">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M9.23499 7.50002H9.72589M3.99609 7.50002H7.46614M3.99609 4.50393H9.98826M12.9843 2.52347V9.47624C12.9843 10.3176 12.3023 10.9997 11.4609 10.9997H6.17708C6.0514 10.9997 5.93085 11.0496 5.84195 11.1385L4.20292 12.7775C4.13734 12.8431 4.05949 12.8951 3.97381 12.9306C3.88813 12.9661 3.7963 12.9844 3.70356 12.9844C3.31356 12.9844 2.9974 12.6682 2.9974 12.2782V11.4736C2.9974 11.2119 2.78521 10.9997 2.52343 10.9997C1.68207 10.9997 1 10.3176 1 9.47624V2.52347C1 1.6821 1.68207 1.00003 2.52343 1.00003H11.4609C12.3023 1.00003 12.9843 1.6821 12.9843 2.52347Z" stroke="#B2B2B2" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </div>
                      
                      <button class="btn-reset balloon__address_btn-copy js-balloon-copy">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M2.63434 13.6668H8.69834C9.86367 13.6668 10.8197 12.7922 10.969 11.6668H11.365C11.9751 11.6661 12.5601 11.4234 12.9915 10.992C13.4229 10.5606 13.6656 9.97563 13.6663 9.3655V2.63483C13.6656 2.02469 13.4229 1.43975 12.9915 1.00832C12.5601 0.57689 11.9751 0.334202 11.365 0.333496H5.30101C4.69087 0.334202 4.10593 0.57689 3.6745 1.00832C3.24307 1.43975 3.00038 2.02469 2.99967 2.63483V3.00016H2.63434C2.02421 3.00087 1.43926 3.24356 1.00783 3.67499C0.576401 4.10642 0.333714 4.69136 0.333008 5.3015V11.3655C0.333714 11.9756 0.576401 12.5606 1.00783 12.992C1.43926 13.4234 2.02421 13.6661 2.63434 13.6668ZM4.33301 2.63483C4.33301 2.1015 4.76701 1.66683 5.30101 1.66683H11.365C11.8983 1.66683 12.333 2.10083 12.333 2.63483V9.3655C12.333 9.89883 11.899 10.3335 11.365 10.3335H10.9997V5.3015C10.999 4.69136 10.7563 4.10642 10.3248 3.67499C9.89342 3.24356 9.30848 3.00087 8.69834 3.00016H4.33301V2.63483ZM1.66634 5.3015C1.66634 4.76816 2.10034 4.3335 2.63434 4.3335H8.69834C9.23167 4.3335 9.66634 4.7675 9.66634 5.3015V11.3655C9.66634 11.8988 9.23234 12.3335 8.69834 12.3335H2.63434C2.10101 12.3335 1.66634 11.8995 1.66634 11.3655V5.3015Z" fill="#B2B2B2"/>
                        </svg>
                      </button>
                    </div>
                                        `,
                                    },
                                    getPointOptions()
                                );

                                // Открытие балуна
                                placemark.events.add("balloonopen", function () {
                                    if (myMap.getZoom() < 15) {
                                        setTimeout(() => {
                                           // myMap.setZoom(15);
                                        }, 450);
                                    }
                                    setTimeout(() => {
                                       
                                      //  myMap.panTo(coordinates, { duration: 300 });
                                    }, 1);
                                    balloonCustom(placemark);
                                    // Градиент маркер
                                    placemark.options.set(
                                        "iconImageHref",
                                        // "/img/svg/marker-inflave-gr.svg"
                                        ""
                                    );
                                });

                                // Закрытие балуна
                                placemark.events.add("balloonclose", function () {
                                    // Возвращаем маркер
                                    placemark.options.set(
                                        "iconImageHref",
                                        "/img/svg/marker-inflave-black.svg"
                                    );
                                });

                                clusterer.add(placemark);

                                if(all){
                                    placemarkArray.push(placemark);
                                }

                               
                           
                    }
                });
                
            }

            addPlacemarksToCluster(data, false, true);

            // Добавил кластер
            myMap.geoObjects.add(clusterer);

            document.querySelector('#plus').addEventListener('click', () => {
                myMap.setZoom(myMap.getZoom() + 1, { duration: 300 });
            })
            document.querySelector('#minus').addEventListener('click', () => {
                myMap.setZoom(myMap.getZoom() - 1, { duration: 300 });
            })


            // добавление поиска
            myMap.controls.add(searchControl);
            // кнопка местоположения
            myMap.controls.add(geolocationControl);

            let filterItems = document.querySelectorAll('.where__filter_item');
            let activeFilterText = document.querySelector('.where__filter_check-text');

            filterItems.forEach(filterItem => {
                filterItem.addEventListener('click', function () {

                    const selectedName = this.getAttribute('data-shop-name');
                    activeFilter = activeFilter === selectedName ? null : selectedName;

                    if (activeFilter != null) {
                        
                        filterItems.forEach(item => item.classList.remove('js-active-filter'));
                        this.classList.add('js-active-filter');
                        if (this != filterItems[0]) {
                            activeFilterText.textContent = activeFilter;
                        } else {
                            activeFilterText.textContent = this.getAttribute('data-name-filter-def');
                        }
                    } else {
                        if (this != filterItems[0]) {
                            this.classList.remove('js-active-filter');
                        }
                        activeFilterText.textContent = filterItems[0].getAttribute('data-name-filter-def');
                        filterItems[0].classList.add('js-active-filter');
                    }

                 

                    // Очищаем предыдущие результаты
                   // clusterer.removeAll();
                   if (activeFilter != null &&  activeFilter != "") {  // если применен фильтр
                        clusterer.removeAll();
                        addPlacemarksToCluster(data, activeFilter, false);
                   }
                   else{  // если все метки
                        clusterer.removeAll();
                        clusterer.add(placemarkArray);
                   }
                   
                    // Обновляем маркеры на основе выбранного фильтра

                   // addPlacemarksToCluster(data, activeFilter);


                });
            });
        }

        function balloonCustom(el) {
            let balloon = document.querySelector(".balloon");
            let address = document.querySelector(".balloon__address").textContent;
            let copy = balloon.querySelector(".js-balloon-copy");
            let feedback = balloon.querySelector(".js-balloon-feedback");

            balloon.parentElement.parentElement.style.cssText = `
            width: 100%;
            height: 100%;
            `

            feedback.addEventListener('click', () => {
                let modal = document.querySelector("[data-graph-target='shop-message']");
                let fieldId = modal.querySelector('#id-shop');

                fieldId.value = balloon.getAttribute('data-shop');
            })

            copy.addEventListener("click", () => {
                //alert("hello");

                document.querySelector(".balloon__address_btn-copy").parentElement.children[0].children[1].classList.add("balloon__copy_show");

                // Создаем временный элемент textarea для копирования текста
                const textarea = document.createElement("textarea");
                textarea.value = address;
                document.body.appendChild(textarea);

                // Выделяем текст в textarea и копируем его в буфер обмена
                textarea.select();
                document.execCommand("copy");

                // Удаляем временный элемент textarea
                document.body.removeChild(textarea);
            });
        }
    } catch (e) { }
} 
